import { render, staticRenderFns } from "./banners.vue?vue&type=template&id=7e626904&"
import script from "./banners.vue?vue&type=script&lang=js&"
export * from "./banners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports